import React, { useState, useEffect, useContext } from 'react'
import Banner from '../component/Common/Banner'
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { compose } from 'redux'
import { connect } from "react-redux";
import * as actions from "../actions/booking";
import { Link } from 'react-router-dom';
import Swal from "sweetalert2";
import { IoShareSocialOutline, IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';
import arrow from './../assets/img/custom/arrow.png'
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import { IoCloseCircle } from 'react-icons/io5';

const BookingModal = (props) => {
    const { t, i18n } = useTranslation();
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [service, setService] = useState("");
    const [doctor, setDoctor] = useState("");
    const [mobile, setMobile] = useState('')
    const [type, setType] = useState('')
    const [countryCode, setCountryCode] = useState('')

    const closeBookingModal = () => setShowBookingModal(false);

    const openBookingModal = () => setShowBookingModal(true);

    const handleMobileChange = (value, data, event, formattedValue) => {

        setMobile(value)
        setCountryCode(data.dialCode)
    }

    const submitBooking = () => {
        let data = {
            name: name,
            mobile: mobile,
            email: email,
            message: message,
            type: props.type,
            servicename: props.servicename,
            service: props.service?props.service:'',
            doctor: props.doctor?props.doctor:'',
        }
        const onSuccess = (res) => {
            closeBookingModal()
            Swal.fire(t('thankyoumsg'), t("thankyousubhead"), 'success')
        }
        props.create(data, onSuccess)
       
    };

    return (
        <>
            <button className='btn cartbtn btn-sm' onClick={openBookingModal}>
                {props.title?props.title:t('bookappt')}
            </button>
            <Modal show={showBookingModal} onHide={closeBookingModal} centered={true}>

                <Modal.Body>
                <a className='float-right' onClick={closeBookingModal}><IoCloseCircle color='#838383' /></a>
                    <div className='row'>
                        <div className='col-lg-12 col-12 text-center mb-4'>
                            <div>
                                {/* <small className='text-warn'>Lorem Ipsum</small> */}
                                <Modal.Title className='font-weight-light'>{t('bookappt')}</Modal.Title>

                            </div>


                        </div>
                        </div>
                        <form onSubmit={(e)=> {e.preventDefault();submitBooking();}}>
                        <div className='row'>
                        <div className='col-lg-12 col-12'>
                            <div className="default-form-box mb-3">
                                <label>{t('name')}<span className="text-danger">*</span></label>
                                <input type="text" className="form-control" value={name} onChange={e => setName(e.currentTarget.value)} required />
                            </div>

                            <div className="default-form-box mb-3">
                                <label>{t('email')}<span className="text-danger">*</span></label>
                                <input type="text" className="form-control" value={email} onChange={e => setEmail(e.currentTarget.value)} required minLength="8" />
                            </div>

                            <div className="default-form-box mb-3">
                                <label>{t('mobileNumber')}<span className="text-danger">*</span></label>
                                <PhoneInput
                                    country={'ae'}
                                    value={mobile}
                                    onChange={handleMobileChange}
                                    inputclassName="w-100"
                                    minLength="10"
                                    inputProps={{required: true, minLength:"10"}}
                                />
                            </div>

                            <div class="form-group mb-3">
                                <label>Comments</label>
                                <textarea class="form-control" value={message} onChange={e => setMessage(e.currentTarget.value)} rows="2"></textarea>
                            </div>

                        </div>

                        {/* <div className='col-lg-6 col-6'>
                            <Button className='btn-block' variant="secondary" onClick={closeBookingModal}>
                                Close
                            </Button>

                        </div> */}
                        <div className='col-lg-12 col-12'>

                            <button type='submit' className='btn btn-block bg-eve' >
                                {t("submit")}
                            </button>
                        </div>
                        </div>
                        </form>
                   
                </Modal.Body>

            </Modal>
        </>
    )
}


const mapStateToProps = state => ({
    bookings: state?.booking?.bookings,
    meta: state?.booking?.metaBooking,

})

const mapActionToProps = {

    create: actions.create,

}


export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps)
)(BookingModal);